import DIApi from './_diApi';

// / Api cho danh mục cán bộ
class AccountingObjectAPI extends DIApi {
  controllerName = 'AccountingObjects';

  /**
   * Xử lý lấy đối tượng theo loại
   * tvtoan 17.5.2023
   */
  getDataObjectByObjectCategoryCode(accountingObjectCategoryCode = '') {
    const request = {
      url: [
        this.getAPIUrl(),
        '/GetDataObjectByObjectCategoryCode?objectCategoryCode=',
        accountingObjectCategoryCode,
      ].join(''),
    };
    return this.getAsync(request);
  }
}

export default new AccountingObjectAPI();
